import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Preloader from "../components/preloader/Preloader";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { Container } from "react-bootstrap";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import StudentAttendanceHome from '../components/student_attendance/StudentAttendanceHome';
import axios from 'axios';

class StudentAttendance extends Component {
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };
  render() {

   // Your API endpoint
    const apiUrl = 'https://wapi.rizee.in/webhook';



    axios.post(apiUrl, {})
      .then(response => {
        console.log("response", response)
      })
      .catch(err => {
        // Handle errors
        console.log("error");
      });

      axios.post(apiUrl, {}, {
        headers: {
          'Content-Type': 'application/json',
          // Add any other required headers here
        },
      })
        .then(response => {
          console.log("response", response);
        })
        .catch(error => {
          // Handle errors
          console.log("error", error);
        });


    
    


    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />

        </div>
        <div className="main-wrapper">

          <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>
            <Container fluid>
             <StudentAttendanceHome />
            </Container> 
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default StudentAttendance;
